import {
  AdmissionFromSearch,
  downloadWorkflowPdf,
} from "../../../services/AdmissionsService";
import {readResidentEmailAnswer} from "../../../models/AdmissionModel.helpers";

export const hasPrimaryContactWithMail = (admission: AdmissionFromSearch) =>
  admission.answers.emergencyContact?.value.some(
    ({
      email,
      primaryContact,
    }: {
      email: string;
      primaryContact: "true" | "false";
    }) => primaryContact === "true" && email?.length,
  );

export const hasResidentEmail = (admission: AdmissionFromSearch) =>
  Boolean(readResidentEmailAnswer(admission as any)?.length);

export const redirectToAdmissionPDF = (admission: AdmissionFromSearch) =>
  downloadWorkflowPdf({
    workflowId: admission.id,
    type: "full",
    status: admission.status,
  });
